var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center full-width pt-5 pb-5"},[_c('div',{staticClass:"loader display-inline-block position-static",style:(_vm.style)},[_c('span',{staticClass:"loader-inner w-100 d-inline-block",style:(_vm.innerStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }